<template>
    <section class="section-service" id="seciton-service" v-if="showPopup">
        <div @click="closeWxService" class="mask"></div>
        <div class="service-content" v-if="isShowServiceList">
            <div class="title-img img-box">
                <img alt src="../../assets/image/icon-service.png" />
            </div>
            <!-- <p v-if="env.isWechatMini" class="title-txt">仅支持在APP/微信公众号咨询</p>
            <template v-else> -->
            <p class="title-txt">{{ serviceTitle }}</p>
            <!-- 是否自定义电话列表 -->
            <template v-if="customCallList.length > 0">
                <a :key="index" @click="callPhoneOrOnline(item)" v-for="(item, index) in customCallList">
                    <button class="service-bt ui-btn-main-3">{{ item.text }}</button>
                </a>
            </template>
            <template v-else>
                <a href="tel:400-606-9068" v-if="isTelService">
                    <button class="service-bt ui-btn-main-3">拨打客服电话</button>
                </a>
                <span
                    :data-zzc-event-tj="onlineServiceTj"
                    :href="serviceLink"
                    @click="gotoOnlineService"
                    v-if="isOnlineService"
                >
                    <button class="service-bt ui-btn-main-3">接入在线客服</button>
                </span>
                <a @click="openWxService" href="javascript:void(0);" v-if="isWxService">
                    <button class="service-bt ui-btn-main-3">咨询微信小助手</button>
                </a>
            </template>
            <!-- </template> -->

            <button @click="closeService" class="close">关闭</button>
        </div>
        <div class="service-wxcode" v-if="isShowWxService">
            <div class="wxcode-content">
                <p class="txt">联系方式</p>
                <div class="code-box img-box">
                    <img alt src="../../assets/image/mine/official-service.jpg" />
                </div>
                <p class="tips wxcode-copy" data-clipboard-text="blackunique08" onclick>
                    长按识别二维码，或搜索微信号
                    <br />blackunique08，添加官方客服
                </p>
                <button @click="closeWxService" class="bt">知道了</button>
            </div>
        </div>
    </section>
</template>
<script>
const ZZCFL = window.ZZCFL;
import Clipboard from 'clipboard';
import Vue from 'vue';
import { getKfLink, getGDMobileServiceUrl } from 'root/common/util/getYunKeFu';
import env from 'root/common/util/env';
import storage from '../../../common/util/storage';

Vue.use(ZZCFL.LazyLoad);

export default {
    name: 'service',
    props: {
        //是否展示客服弹窗
        show: {
            default: false,
        },

        serviceTitle: {
            default: '请选择客服类型',
            type: String,
        },

        //是否展示客服电话按钮
        isTelService: {
            default: false,
        },

        //是否展示在线客服按钮
        isOnlineService: {
            default: true,
        },

        //是否展示微信小助手按钮
        isWxService: {
            default: false,
        },

        //在线客服统计参数
        onlineServiceTj: {
            default: '',
            type: String,
        },

        // 自定义的电话列表
        customCallList: {
            default: function() {
                return [];
            },
            type: Array,
        },

        //在线客服跳转参数
        // 12.15，默认跳转阿里客服，外部传入的zuzuche客服链接禁止
        // onlineServiceUrl: {
        //     default: '/privilege_module/index?ZZCAppArg=AppOpenPage&key=kf_shop',
        //     type: String,
        // },

        // 是否使用阿里云客服
        isUseAliService: {
            default: false,
            type: Boolean,
        },

        // 获取阿里云客服地址失败，默认的跳转地址
        aliDefaultLink: {
            default: '',
            type: String,
        },

        // 用于区分客服的类型 充值：RECHARGE 卡券：TICKET 商超：SUPERMARKET 加油：OIL
        aliServiceType: {
            default: 'BLANKED',
            type: String,
        },
        params: {
            default: function() {
                return {};
            },
            type: Object,
        },
        paramsEntry: {
            default: '',
            type: String,
        },
    },
    data() {
        return {
            //是否展示微信小助手弹窗
            isShowWxService: false,
            //是否展示客服列表弹窗
            isShowServiceList: true,
            aliServiceLink: null, // 判断是否阿里云客服
            // onlineServiceUrl: 统一改为跳转阿里客服，外部传入的prop为zuzuche，禁止
            onlineServiceUrl: 'https://cschat.antcloud.com.cn/index.htm?tntInstId=DGORNANY&scene=SCE00187956',
            env: env,
        };
    },
    created() {
        if (this.isUseAliService) {
            this.getYunKeFuLink();
        }
    },
    mounted() {
        const self = this;
        self.initCopyBtn();
    },
    watch: {
        aliDefaultLink() {
            if (this.isUseAliService) {
                this.getYunKeFuLink();
            }
        },
        show() {
            // 当只有在线客服的情况下直接跳到在线客服，不展示弹窗
            if (this.show && this.isOnlyOnlineService)
                setTimeout(() => {
                    this.$emit('close');
                    this.gotoOnlineService();
                }, 500);
        },
    },

    computed: {
        serviceLink() {
            const sourceChannel = storage.get(storage.keys.privilegeSourceChannel);
            // 如果是特权输出到广东移动
            if (sourceChannel === 'changyou') return getGDMobileServiceUrl();
            if (this.aliServiceLink) {
                return this.aliServiceLink;
            } else {
                return this.onlineServiceUrl;
            }
        },
        isOnlyOnlineService() {
            // 是否只有在线客服
            return (
                (!this.customCallList || !this.customCallList.length) &&
                !this.isTelService &&
                this.isOnlineService &&
                !this.isWxService
            );
        },
        showPopup() {
            // 当只有在线客服的情况下直接跳到在线客服，不展示弹窗
            if (this.isOnlyOnlineService) {
                return false;
            }
            return this.show;
        },
    },

    methods: {
        /**
         * 初始化复制按钮事件
         *
         */
        initCopyBtn() {
            const clipboard = new Clipboard('.wxcode-copy');
            clipboard.on('success', e => {
                ZZCFL.Toast('复制成功~');
                e.clearSelection();
            });

            clipboard.on('error', e => {
                ZZCFL.Toast('复制失败~');
                console.error('Action:', e.action);
                console.error('Trigger:', e.trigger);
            });
        },

        /*
         * 打开微信小助手弹窗
         * */
        openWxService() {
            const self = this;
            self.isShowWxService = true;
            self.isShowServiceList = false;
        },

        /*
         * 关闭微信小助手弹窗
         * */
        closeWxService() {
            const self = this;
            self.isShowWxService = false;
            self.isShowServiceList = true;
            self.closeService();
        },

        /*
         * 关闭客服弹窗
         * */
        closeService() {
            const self = this;
            self.$emit('close');
        },

        /*
         * 打开在线客服
         * */
        gotoOnlineService() {
            this.$emit('before-open');
            window.location.href = this.serviceLink;
        },

        callPhoneOrOnline(item) {
            if (item.phone) {
                location.href = 'tel:' + item.phone;
            } else {
                this.gotoOnlineService();
            }
        },

        async getYunKeFuLink() {
            let servicePrms = JSON.parse(JSON.stringify(this.params));
            let entryType = this.paramsEntry;
            const data = await getKfLink({
                oriKfLink: this.aliDefaultLink || this.onlineServiceUrl, // 原链接跳转地址，如果云客服不切换或不生效，则会跳转原链接
                biz: this.aliServiceType, // 办卡使用BLANKED标识
                entryType,
                servicePrms,
            });
            if (!data) {
                window.ZZCFL.Toast('网络繁忙，请稍后再试');
                return;
            }

            // data 为返回链接字符串
            this.aliServiceLink = data;
            // window.location.href = data;
        },
    },
};
</script>

<style lang="scss">
#seciton-service {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    .mask {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.7);
    }
    .service-content {
        width: 6.3rem;
        padding: 1.2rem 0 0;
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        background-color: #fff;
        border-radius: 5px;
        a {
            display: block;
            margin: 0 auto;
            &:link {
                color: #fff;
            }
            &:visited {
                color: #fff;
            }
        }
        .title-img {
            width: 2.17rem;
            height: 2.08rem;
            position: absolute;
            top: -0.98rem;
            left: 50%;
            transform: translate3d(-50%, 0, 0);
        }
        .title-txt {
            line-height: 0.49rem;
            font-size: 0.32rem;
            color: #333;
            padding-bottom: 0.26rem;
            text-align: center;
            font-weight: bold;
        }
        .service-bt {
            width: 5.3rem;
            height: 0.8rem;
            line-height: 0.8rem;
            display: block;
            margin: 0.3rem auto 0;
            background: #ddc47d;
            box-shadow: none;
            border-radius: 4px;
            font-size: 0.32rem;
        }
        .close {
            width: 100%;
            line-height: 1rem;
            font-size: 0.32rem;
            color: #d19a09;
            text-align: center;
            border-top: 1px solid rgba(221, 224, 230, 0.5);
            margin-top: 0.4rem;
        }
    }
    .service-wxcode {
        width: 6.3rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        background-color: #fff;
        border-radius: 4px;
        .txt {
            line-height: 0.48rem;
            font-size: 0.32rem;
            font-weight: bold;
            color: #333;
            padding: 0.3rem 0;
            text-align: center;
        }
        .code-box {
            width: 2.8rem;
            height: 2.8rem;
            margin: 0 auto;
        }
        .tips {
            line-height: 0.45rem;
            font-size: 0.32rem;
            color: #333;
            margin: 0.2rem 0 0.3rem;
            text-align: center;
        }
        .bt {
            width: 100%;
            height: 1rem;
            line-height: 1rem;
            font-size: 0.32rem;
            color: #d19a09;
            position: relative;
            &:after {
                width: 100%;
                height: 1px;
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                background: linear-gradient(#dde0e6, rgba(255, 255, 255, 0));
            }
        }
    }
}
</style>
